import { Dispatch, SetStateAction } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import MyModal from '../../../../../../../components/Modal';
import { ReactCalendarCustomStyle } from '../../../../../../../components/ReactCalendarCustomStyle';
import useThemeContext from '../../../../../../../contexts/theme';
import useDownloadOtimizationModal from './useDownloadOtimizationModal';

interface IDownloadOtimizationModal {
  downloadModalShow: boolean;
  setDownloadModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

export default function DownloadOtimizationBaseModal({
  downloadModalShow,
  setDownloadModalShow,
  setIsLoading,
}: IDownloadOtimizationModal) {
  const {
    downloadReport,
    handleSpecificPeriodChange,
    specificPeriod,
    specificPeriodLabel,
  } = useDownloadOtimizationModal({
    setIsLoading,
    setDownloadModalShow,
  });

  const { selectedTheme } = useThemeContext();

  return (
    <MyModal
      show={downloadModalShow}
      title="Download Planilha de Otimização (Base)"
      centeredBody
      modalBody={(
        <>
          <h6>Selecione o período para baixar a planilha</h6>
          {selectedTheme === 'dark' ? (
            <ReactCalendarCustomStyle>
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            </ReactCalendarCustomStyle>
          ) : (
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
          )}
          <small>
            Será baixado a planilha de otimização {specificPeriodLabel}
          </small>
        </>
      )}
      type="action"
      closeButtonLabel="Fechar"
      actionButtonLabel="Baixar"
      onClose={() => setDownloadModalShow(false)}
      onAction={() => downloadReport()}
      isActionButtonDisabled={!specificPeriod}
    />
  );
}
